module.exports = new __parcel__URL__("virtual-agent-intent-template-sidebar-app-skeleton.tpl.e2ff8557.svg").toString();